import { createTranslations } from '@npco/common-utils-translations'

export const interimStatementListItemTranslations = createTranslations({
  interimTitle: '{title} (Interim)',
})
